import BaseDB from './base';

const dbRename = (name) => `ck-${name}`;
const IWDB = new BaseDB(dbRename('IWdb'));
const SectionDB = new BaseDB(dbRename('sectionsDB'));
const CriteriaDB = new BaseDB(dbRename('criteriaDB'));
const ReportDB = new BaseDB(dbRename('ReportDB'));
export default { IWDB, SectionDB, CriteriaDB, ReportDB };
export { IWDB, SectionDB, CriteriaDB, ReportDB };
